import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import Select from '@src/components/Select';
import FrCustomUsersSvg from '@src/svgs/fr-custom-users.svg';
import FrImportSvg from '@src/svgs/fr-import.svg';
import { Avatar } from '@src/components/Avatar';
import { SelectedRecruiter } from '@src/containers/Source/enums/selectedRecruiter.enum';
import { RecruitersProps } from './props';
import './styles.scss';

export const Recruiters: FC<RecruitersProps> = ({ recruiters, onSelectRecruiter, selectedRecruiterId, isLoading }) => {
  if (isLoading) {
    return <div className="openings-recruiters-filter__skeleton pulse-fade" />;
  }

  const sortedRecruiters = [...recruiters].sort((a, b) => {
    return a?.fullName?.localeCompare(b?.fullName || '') || 0;
  });

  const options = [
    { fullName: 'Everyone', id: SelectedRecruiter.ALL_RECRUITERS_OPTION },
    { fullName: 'Imported', id: SelectedRecruiter.SCRAPED_OPENINGS_OPTION },
    ...sortedRecruiters,
  ];

  const selectedOptionId = options.some(({ id }) => id === selectedRecruiterId)
    ? selectedRecruiterId
    : recruiters.length > 1
    ? SelectedRecruiter.ALL_RECRUITERS_OPTION
    : SelectedRecruiter.SCRAPED_OPENINGS_OPTION;

  const selectedOption = options.find(({ id }) => id === selectedOptionId);

  if (selectedOptionId !== selectedRecruiterId) {
    onSelectRecruiter(selectedOptionId);
  }

  return (
    <div className="openings-recruiters-filter">
      <Select
        className="inbox-dropdown"
        label=""
        onSelect={({ id }) => onSelectRecruiter(id)}
        optionKey="id"
        optionValue={recruiter => (
          <div className="openings-recruiters-filter__option">
            <Avatar
              avatarColor={recruiter.avatarColor}
              initials={recruiter.nameInitials}
              size="x-small"
              source={recruiter.avatar?.fullUrl}
            >
              {recruiter.id === SelectedRecruiter.ALL_RECRUITERS_OPTION && <Svg src={FrCustomUsersSvg} />}
              {recruiter.id === SelectedRecruiter.SCRAPED_OPENINGS_OPTION && <Svg src={FrImportSvg} />}
            </Avatar>

            <span className="openings-recruiters-filter__name">{recruiter.fullName}</span>
          </div>
        )}
        options={options}
        selectedOption={selectedOption}
      />
    </div>
  );
};
